import React, {Suspense} from 'react';
import {observer} from "mobx-react-lite"
import menuStore from "common/menu/store/MenuStore";
import MenuInfo from "common/menu/model/MenuInfo";
import UI from 'components/UI';
import PageLoading from "components/loading";
import AuthMenuLink from "components/link";
import {computed} from "mobx";

type MainLeftMenuULProps = {
    menu?: MenuInfo;
    className: string;
    isFirst: boolean;
}

const MainLeftMenuUL = observer(({className, menu, isFirst}: MainLeftMenuULProps) => {
    if (menu){
        return (
            <>
                <UI.If test={isFirst}>
                    <p className="tit-d1">{menu.menuNm}</p>
                </UI.If>
                <ul className={className}>
                    {menu.children?.map(value =>
                        <MainLeftMenuLI key={value.menuId} menu={value}/>
                    )}
                </ul>
            </>
        )
    }else{
      //  return <PageLoading/>
    return <></>
    }
});

const MainLeftMenuLI = observer(({menu}: { menu: MenuInfo; }) => {
    const active = computed(() => menu.active ? "active" : "").get();
    const opened = computed(() => menu.opened ? "ctr active" : "ctr").get();
    const hasChildren = menu.children &&  menu.children.length > 0 || false;
    const toggleOpened = () => menuStore.toggleOpened(menu);

    return (
        <Suspense fallback={<PageLoading/>}>
            <li className={active}>
                <UI.If test={hasChildren}>
                    <button type='button' className={opened} onClick={toggleOpened}>{menu.menuNm}</button>
                    <MainLeftMenuUL menu={menu} className={"d2"} isFirst={false}/>
                </UI.If>
                <UI.If test={!hasChildren}>
                    <AuthMenuLink menuId={menu.menuId} className={"no-sub"}/>
                </UI.If>
            </li>
        </Suspense>
    );
});

function PortalAside() {
    return (
        <aside className='fww-aside'>
            <Suspense fallback={<PageLoading/>}>
                <MainLeftMenuUL
                    menu={menuStore.currentTopMenu}
                    className={'d1'}
                    isFirst={true}
                />
            </Suspense>
        </aside>
    );
}

export default observer(PortalAside);